import "./assets/common/css/reset.css";

import App from "./App.vue";
import { createApp } from "vue";

createApp(App).mount("#app");
